import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Section } from 'interfaces/SectionTypes';
import { Alert } from '@mui/material';

import SoftwareDownloadButton from 'components/service-center/SoftwareDownloadButton';

import { MyToverAPI } from '../../../api/MyToverAPI';
import PageSectionContainer from '../PageSectionContainer';

const SoftwareDownloadSection = ({ options }: Section) => {
  const { t } = useTranslation();
  const [binaryLoading, setBinaryLoading] = useState(false);
  const [binary, setBinary] = useState({
    url: '',
    version: '',
    hwversion: '',
    error: '',
  });
  const [error, setError] = useState<boolean | string>(false);
  const { tovertafel: version } = options;

  async function getBinaryUpdateInfo() {
    try {
      setBinaryLoading(true);
      const { success, parsed } = await MyToverAPI.getSoftwareUpdate(version.toUpperCase());

      if (!success) return;

      console.log(parsed);
      if (parsed.data.url) {
        setBinary(parsed.data);
      } else {
        setError('service-center.software-update.not-available');
      }
    } catch (error) {
    } finally {
      setBinaryLoading(false);
    }
  }

  useEffect(() => {
    if (!binaryLoading && !binary.url) {
      getBinaryUpdateInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (binary.url) {
    return (
      <PageSectionContainer className="section__software-download">
        <SoftwareDownloadButton binary={binary} />
      </PageSectionContainer>
    );
  } else if (error) {
    return (
      <PageSectionContainer sx={{ p: 0 }}>
        <Alert severity="warning">{t(error)}</Alert>
      </PageSectionContainer>
    );
  }

  return null;
};
export default SoftwareDownloadSection;
